import React, { useState } from "react";
import { Container, Row, Col, Button, Modal, ModalBody, ModalFooter, Card, CardBody, FormFeedback, Label, Input } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import Select from "react-select";

//i18n
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';


const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const CollaboratorManagement = props => {

  //meta title
  document.title = "Collaborator Management";
	const location = useLocation();
  const { getRequest, postRequest } = useRequests();


  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};
  



  const [StandardModal, setStandardModal] = React.useState(false);
  const togStandardModal = async (elementData) => {
    validation.setValues({
      ...validation.values,
          u_id: elementData.u_id,
          welcome_bonus: elementData.collaborator_welcome_bonus,
          referral_code: elementData.collaborator_referral_code
      });
      setStandardModal(true);
  }

      const validation = useFormik({
          enableReinitialize: true,
  
          initialValues: {
          u_id: '',
          welcome_bonus: '',
          referral_code: ''
          },
          validationSchema: Yup.object({
            welcome_bonus: Yup.number()
            .typeError('Welcome bonus must be a number')
            .required('Please enter welcome bonus')
            .positive('Welcome bonus must be greater than 0'),
            referral_code: Yup.string().required('Please enter referral code'),
          }),
          onSubmit: async (values) => {
          try {
              let submit1 = document.getElementById('submit1');
              submit1.disabled = true;
              submit1.textContent = 'Processing...';
  
              const jsonpar = JSON.stringify({
              u_id: values.u_id,
              collaborator_welcome_bonus: values.welcome_bonus,
              collaborator_referral_code: values.referral_code
              });
              const res = await postRequest('update-collaborator-referral-and-bonus', jsonpar);
              if (res && res.code === 200) {  
                  setAlertData((AlertData) => ({
                  ...AlertData,
                  variant: 'success',
                  message: res.message,
                  }));
              }
              else {
              setAlertData((AlertData) => ({
                  ...AlertData,
                  variant: 'error',
                  message: res.message,
              }));
              }
              resetAlertData();
              
              submit1.disabled = false;
              submit1.textContent = 'Submit';
  
              setStandardModal(false);
              handleLoadGetUsers();
          } catch (error) {
              console.error("Error : ", error);
          }
          }
      });

  const [UsersTBody, setUsersTBody] = React.useState('');
  const handleT1Body = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.u_id}</td>
        <td>{element.first_name}</td>
        <td>{element.last_name}</td>
        <td>{element.email}</td>
        <td>{element.country}</td>
        <td>+{element.country_code} {element.phone.slice(0, 6)}****&nbsp;
            {parseInt(element.is_phone_verified) === 1 ? (
              <CheckCircleIcon style={{ color: 'green' }} />
            ) : (
              <CancelIcon style={{ color: 'red' }} />
            )}
        </td>
        <td className="text-center">
          <div className="centerLink">
            <Link title="Collaborator Details" to={"/collaborator-details/" + btoa(element.u_id)} className="font-size-14 bg-primary edit-box"><i className="bx bx-detail"></i></Link>            
            <Link title="Update Welcome Bonus and Referral code" to="#" className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal(element)}><i className="bx bxs-edit"></i></Link>
          </div>
        </td>
      </tr>
    ));

    setUsersTBody(tempTBody);
  }
  const handleLoadGetUsers = async () => {
    const res = await getRequest('get-users');
    if (res && res.code === 200) {
      let originalText = res.data;

      let collaboratorsData = [];
      originalText.forEach(element => {
        if(element.collaborator_referral_code){
            collaboratorsData.push(element);
        }
      });

      handleT1Body(collaboratorsData);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="9" className="text-center">No records found</td>
                      </tr>);

      setUsersTBody(tempTBody);

      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  const [AllCountriesData, setAllCountriesData] = React.useState([]);
  const handleLoadGetAllCountries = async () => {
    const res = await getRequest('get-all-countries');
    if (res && res.code === 200) {
      let originalText = res.data;

      let tempArr = [{label: 'All', value: 'All'}];
      originalText.forEach(element => {
        let temp = {
            label: element.country_name,
            value: element.country_name,
        };
        tempArr.push(temp);
      });
      tempArr = [{
          options: tempArr
      }];
      setAllCountriesData(tempArr);
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }
  React.useEffect(() => {
    handleLoadGetUsers();
    handleLoadGetAllCountries();

    if (typeof location.state !== 'undefined' && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
		}
  }, []);


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Collaborator Management")} />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div className="table-responsive mb-0">
                      <table className="table table-hover table-highlight" style={{ minWidth: '1500px' }}>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email ID</th>
                            <th>Country Name</th>
                            <th>Mobile No.</th>
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {UsersTBody}
                        </tbody>
                      </table>
                    </div>
                    <div className="infoIcon">

                    <div className="infoIconBox">
                    <i className="bx bx-detail"></i>
                    <p>Collaborator Details</p>
                    </div>

                    <div className="infoIconBox">
                    <i className="bx bxs-edit"></i>
                    <p>Update Welcome Bonus and Referral code</p>
                    </div>
                    
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>
      </div>




      <Modal isOpen={StandardModal} backdrop={'static'} centered className="transation">
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Update Welcome bonus and Referral code</h5>
            <button type="button" onClick={(e)=>setStandardModal(false)} className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
          <div className="mb-3">
                    <Label className="form-label">Welcome Bonus :</Label>
                    <Input
                      name="welcome_bonus" 
                      type="text" 
                      placeholder={'Enter Welcome Bonus'}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.welcome_bonus || ""}
                      invalid={
                        validation.touched.welcome_bonus && validation.errors.welcome_bonus ? true : false
                      }
                    />
                    {validation.touched.welcome_bonus && validation.errors.welcome_bonus ? (
                      <FormFeedback type="invalid">{validation.errors.welcome_bonus}</FormFeedback>
                    ) : null}
                  </div>

                  <div className="mb-3">
                    <Label className="form-label">Referral code  :</Label>
                    <Input
                      name="referral_code" 
                      type="text" 
                      placeholder={'Enter Referral code'}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.referral_code || ""}
                      invalid={
                        validation.touched.referral_code && validation.errors.referral_code ? true : false
                      }
                    />
                    {validation.touched.referral_code && validation.errors.referral_code ? (
                      <FormFeedback type="invalid">{validation.errors.referral_code}</FormFeedback>
                    ) : null}
                  </div>
          </ModalBody>
          <ModalFooter>
            <Button 
              id="submit1"
              onClick={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            type="button" color="primary" >Submit</Button>
            <Button type="button" color="light" onClick={(e)=>setStandardModal(false)} >Cancel</Button>
          </ModalFooter>
        </div>
      </Modal>

    </React.Fragment>
  );
};

export default withTranslation()(CollaboratorManagement);